<template>
    <div id="O2">
        <customHeader :paso="0" />

        <section>
            <v-row v-if="incidencia != ''" style="align-items: center;margin-top:40px;" class="info-success">
                <v-col cols="auto">
                    <div class="info-check">
                        <img src="/img/O2/tick _2solid.svg" width="40px" />
                    </div>
                </v-col>
                <v-col v-html="incidencia"></v-col>
            </v-row>

            <!-- 1 -->
            <v-row class="numered-title-container" style="align-items: center;">
                <v-col cols="auto" class="pl-0">
                    <div class="numered-title-number" style="color: black; background-color: #F3F3F5">1</div>
                </v-col>
                <v-col>
                    <div class="numered-title" style="color:black;">Datos de contacto</div>
                </v-col>
            </v-row>

            <div class="input-container">
                <div class="label-input">Nombre y apellidos *</div>
                <v-text-field id="input_o2" v-model="formulario.metaData.nombreCliente" maxlength="40" tabindex="1" hide-details></v-text-field>
                <span class="error-label Helvetica" v-html="erroresObligatorios.nombre"></span>
            </div>
            <div class="input-container">
                <div class="label-input">DNI / CIF / Tarjeta Residente / Pasaporte *</div>
                <v-text-field id="input_o2" v-model="localDNI" @change="checkIncidenciaRepetida()" maxlength="40" tabindex="2" hide-details></v-text-field>
                <span class="error-label Helvetica" v-html="errorDNI"></span>
            </div>
            <div class="input-container">
                <div class="label-input">Número móvil *</div>
                <v-text-field id="input_o2" v-model="localAbonado" maxlength="9" tabindex="3" type="tel" hide-details></v-text-field>
                <span class="error-label Helvetica" v-html="errorAbonado"></span>
            </div>
            <div class="input-container">
                <div class="label-input">Teléfono de Contacto</div>
                <v-text-field id="input_o2" v-model="localTelefono" maxlength="9" tabindex="4" type="tel" hide-details></v-text-field>
                <span class="error-label Helvetica" v-html="errorTelefono"></span>
            </div>
            <div class="input-container">
                <div class="label-input">Email *</div>
                <v-text-field id="input_o2" v-model="localEmail" maxlength="60" tabindex="5" type="email" hide-details></v-text-field>
                <span class="error-label Helvetica" v-html="errorEmail"></span>
            </div>
            <div class="input-container">
                <div class="label-input">Dirección *</div>
                <v-text-field id="input_o2" v-model="formulario.metaData.direccionCliente" maxlength="80" tabindex="6" hide-details></v-text-field>
                <span class="error-label Helvetica" v-html="erroresObligatorios.direccion"></span>
            </div>
            <div class="input-container">
                <div class="label-input">Código Postal *</div>
                <v-text-field id="input_o2" v-model="formulario.metaData.cpCliente" maxlength="7" tabindex="7" type="number" hide-details></v-text-field>
                <span class="error-label Helvetica" v-html="erroresObligatorios.cp"></span>
            </div>
            <div class="input-container">
                <div class="label-input">Población *</div>
                <v-text-field id="input_o2" v-model="formulario.metaData.poblacionCliente" maxlength="40" tabindex="8" hide-details></v-text-field>
                <span class="error-label Helvetica" v-html="erroresObligatorios.poblacion"></span>
            </div>

            <div class="input-container">
                <div class="special-label">Horario de Contacto</div>
                <div class="label-input">Cuando contactemos contigo deberás tener a mano tu dispositivo</div>
                <v-row>
                    <v-col cols="12" md="5">
                        <div class="label-input">Desde</div>
                        <div>
                            <v-autocomplete clearable
                                            auto-select-first
                                            rounded="sm"
                                            outlined
                                            v-model="localHorarioDesde"
                                            :items="itemsHorariosDesde"
                                            name="txtHoraDesde"
                                            id="txtHoraDesde"
                                            tabindex="9"
                                            hide-details></v-autocomplete>
                        </div>
                    </v-col>
                    <v-col cols="12" md="5">
                        <div class="label-input">Hasta</div>
                        <div>
                            <v-autocomplete v-if="localHorarioDesde !== '' && localHorarioDesde !== undefined"
                                            clearable
                                            outlined
                                            rounded="sm"
                                            auto-select-first
                                            v-model="localHorarioHasta"
                                            :items="itemsHorariosHasta"
                                            name="txtHoraDesde"
                                            id="txtHoraDesde"
                                            tabindex="10"
                                            hide-details></v-autocomplete>
                            <v-autocomplete v-else
                                            clearable
                                            rounded="sm"
                                            outlined
                                            auto-select-first
                                            v-model="localHorarioHasta"
                                            :items="[]"
                                            name="txtHoraDesde"
                                            id="txtHoraDesde"
                                            tabindex="10"
                                            hide-details></v-autocomplete>
                        </div>
                    </v-col>
                </v-row>
                <span class="error-label Helvetica" v-html="erroresObligatorios.horarioContacto"></span>
            </div>

            <div class="input-container">
                <div class="label-input">Si quieres que tengamos en cuenta cualquier cuestión antes de ponernos en contacto contigo, por favor, indícanoslo aquí:</div>
                <v-textarea id="textarea_observacionesContacto" auto-grow counter :maxlength="200" v-model="observacionesContacto" tabindex="11" hide-details></v-textarea>
            </div>

            <!--2-->
            <v-row class="numered-title-container" style="align-items: center;">
                <v-col cols="auto" class="pl-0">
                    <div class="numered-title-number" style="color: black; background-color: #F3F3F5">2</div>
                </v-col>
                <v-col>
                    <div class="numered-title" style="color:black;">Resumen de la avería</div>
                </v-col>
            </v-row>

            <div class="input-container">
                <div class="label-input">Por favor, indícanos brevemente qué le pasa a tu dispositivo *</div>
                <v-textarea id="textarea_sintomaAveria" auto-grow counter :maxlength="200" tabindex="12" v-model="formulario.linea.sintomaAveria" hide-details></v-textarea>
                <span class="error-label Helvetica" v-html="erroresObligatorios.sintoma"></span>
            </div>
            <div class="input-container">
                <div class="label-input">Albarán de entrega</div>
                <v-row>
                    <v-col cols="auto">
                        <button style="border-radius:30px;" class="button-file Helvetica" @click="pincharFileInput">
                            <span>Examinar</span>
                        </button>
                    </v-col>
                    <v-col>
                        <v-file-input id="formO2fileInput" style="border-radius:15px;" v-model="formulario.albaran" prepend-icon="" tabindex="13" outlined counter-size-string></v-file-input>
                    </v-col>
                </v-row>
                <span class="error-label Helvetica" v-html="erroresObligatorios.albaran"></span>
            </div>
            <div class="input-container">
                <div class="label-input">Número de Serie *</div>
                <div id="o2_input_container">
                    <v-text-field id="o2_input_container_vtextfield" v-model="formulario.metaData.sn" @change="checkIncidenciaRepetida()" maxlength="20" tabindex="14" suffix="" hide-details>
                        <template v-slot:append>
                            <img src="/img/O2/iconoInfo.svg" width="30px" style="margin-top: -15px; margin-right: 5px;" @click="modalSN = true" />
                        </template>
                    </v-text-field>
                    <span class="error-label Helvetica" v-html="erroresObligatorios.sn"></span>
                </div>

            </div>
            <div class="input-container">
                <div class="label-input">IMEI</div>
                <div id="o2_input_container">
                    <v-text-field id="o2_input_container_vtextfield" v-model="formulario.metaData.imei" @change="checkIncidenciaRepetida()" maxlength="20" tabindex="15" suffix="" hide-details>
                        <template v-slot:append>
                            <img src="/img/O2/iconoInfo.svg" width="30px" style="margin-top: -15px; margin-right: 5px;" @click="modalIMEI = true" />
                        </template>
                    </v-text-field>
                </div>
            </div>

            <div class="input-container">
                <div class="label-input">Tipo de dispositivo</div>
                <v-autocomplete v-if="TiposModelos != null"
                                clearable
                                rounded="sm"
                                outlined
                                auto-select-first
                                v-model="pedirDesplegables.idTipoModelo"
                                :items="TiposModelos"
                                item-text="DESCRIPCION"
                                item-value="ID"
                                tabindex="16"
                                id="TiposModelos"
                                hide-details></v-autocomplete>
            </div>

            <div class="input-container">
                <div class="label-input">Marca</div>
                <div v-if="pedirDesplegables.idTipoModelo != 1">
                    <v-autocomplete v-if="Fabricantes != null"
                                    clearable
                                    rounded="sm"
                                    outlined
                                    auto-select-first
                                    v-model="pedirDesplegables.idMarca"
                                    :items="Fabricantes"
                                    item-text="DESCRIPCION"
                                    item-value="ID"
                                    @change="changeSelectMarca"
                                    tabindex="17"
                                    hide-details></v-autocomplete>
                </div>
                <div v-else>
                    <v-text-field id="input_o2" v-model="formulario.metaData.marca" maxlength="18" hide-details></v-text-field>
                </div>
            </div>

            <div class="input-container">
                <div class="label-input">Modelo</div>
                <div v-if="pedirDesplegables.idTipoModelo != null && pedirDesplegables.idTipoModelo != 1">
                    <v-autocomplete v-if="Modelos != null"
                                    clearable
                                    rounded="sm"
                                    outlined
                                    auto-select-first
                                    v-model="formulario.idModelo"
                                    :items="Modelos"
                                    item-text="DESCRIPCION"
                                    item-value="ID"
                                    tabindex="19"
                                    hide-details></v-autocomplete>
                </div>
                <div v-else>
                    <v-text-field id="input_o2" v-model="formulario.metaData.modelo" maxlength="14" tabindex="20" hide-details></v-text-field>
                </div>
            </div>

            <div class="input-container">
                <div class="label-input">Color</div>
                <v-text-field id="input_o2" v-model="formulario.metaData.color" maxlength="14" tabindex="21" hide-details></v-text-field>
            </div>
            <div class="input-container">
                <div class="label-input">Fecha de compra</div>
                <v-text-field id="input_o2" v-model="formulario.metaData.fechaCompra" tabindex="22" type="date" hide-details></v-text-field>
            </div>
            <div class="conditions-text">
    
                <label style="font-weight: normal;">
                    Este es un formulario específico en el caso de
                    que quieras reparar tu dispositivo.
                </label><br /><br />
                <label style="font-weight: normal;">
                    Si el equipo esta defectuoso en origen, debes
                    <strong> realizar la solicitud dentro de los primeros 14 días </strong>desde la
                    adquisición del dispositivo. Tendrás que presentar el dispositivo en
                    su embalaje original con todos los accesorios y manuales.
                </label><br /><br />
                <label style="font-weight: normal;">
                    Deberás llamar al 1551 si el dispositivo se ha
                    dañado en el transporte o quieres
                    desistir de la compra realizada y devolver el
                    equipo.
                </label>
            </div>

            <div class="button-search-container">
                <button class="button-search" tabindex="23" @click="comprobarCampos">
                    <span>LEER Y ACEPTAR CONDICIONES</span>
                </button>
            </div>

            <!--MODALES-->
            <v-dialog v-model="modalSN" max-width="800">
                <v-card>
                    <v-img src="/img/O2/Numero_de_serie.jpg"></v-img>
                </v-card>
            </v-dialog>

            <v-dialog v-model="modalIMEI" max-width="800">
                <v-card>
                    <v-img src="/img/O2/IMEI.jpg"></v-img>
                </v-card>
            </v-dialog>

            <v-dialog v-model="modalCondiciones" max-width="800" scrollable>
                <v-card class="condiciones">
                    <v-card-title style="background-color: #0019A5;">
                        <v-row justify="space-between" no-gutters>
                            <v-col style="color:white;font-weight:bold;">CONDICIONES GENERALES DE LA ORDEN DE REPARACIÓN</v-col>
                            <v-col style="color:white;" cols="auto" @click="modalCondiciones = false">X</v-col>
                        </v-row>
                    </v-card-title>
                    <v-card-text style="padding-top:12px;">
                        <span class="azulO2">Telefónica Móviles España, S.A.U., en adelante “O2”, gestionará la reparación de tu dispositivo según las siguientes condiciones:</span>
                        <ul>
                            <li>Si lo has adquirido en propiedad: dispones de 3 años de garantía desde su entrega, conforme al Real Decreto Legislativo 1/2007, de 16 de noviembre, por el que se aprueba el texto refundido de la Ley General para la Defensa de los Consumidores y Usuarios y otras leyes complementarias.</li>
                            <li>Si disfrutas del dispositivo en régimen de arrendamiento: durante el mismo, tienes derecho a recibir un mantenimiento para su buen funcionamiento o a su sustitución por otro del mismo modelo o de similares características si no es posible su reparación y la avería no se debe a un mal uso por tu parte.</li>
                            <li>En cualquier caso: al firmar este documento, habilitas O2, a tramitar la reparación del dispositivo con el servicio técnico homologado del fabricante, según la normativa aplicable al servicio de reparación de aparatos de uso doméstico.</li>
                        </ul>
                        <span class="azulO2">Debes tener en cuenta que no están cubiertos, en ningún caso, los daños originados por: </span>
                        <ul>
                            <li>Un mal trato o uso negligente (ej.: caídas o circunstancias de uso distintas al uso ordinario y habitual).</li>
                            <li>La manipulación del dispositivo por tu cuenta o por un tercero no autorizado.</li>
                            <li>La instalación de programas no realizados o no aprobados por O2.</li>
                            <li>Un caso fortuito (ej.: descarga atmosférica, incendio, inundación o variaciones excesivas de la red eléctrica).</li>
                        </ul>
                        <span class="azulO2">Tienes que entregarnos tu dispositivo cumpliendo estos requisitos:</span>
                        <ul>
                            <li>En su caja original: junto con su albarán de entrega donde conste su código de identificación (ej.: IMEI).</li>
                            <li>Sin accesorios (tapas de batería, punteros, tarjetas de memoria, SIM…): no nos responsabilizamos de su pérdida o deterioro.</li>
                            <li>Sin información: es tu obligación entregar el dispositivo sin ningún contendido. Antes de entregárnoslo, asegura que has guardado tus datos personales, fotos, vídeos y cualquier contenido valioso para ti. Actualizaremos el software y no nos hacemos responsables de la pérdida total o parcial de la información que pudieras tener en el dispositivo.</li>
                            <li>Sin bloqueos: tienes que entregarnos el dispositivo sin ningún código de seguridad que impida acceder al mismo (huella, reconocimiento facial, contraseña…). Si no, no nos responsabilizamos de las consecuencias de devolverte el dispositivo sin haberlo podido reparar.</li>
                        </ul>
                        <span class="azulO2">Si la reparación es incompatible con el régimen de garantía o de mantenimiento que te aplique o simplemente quieres reparar tu dispositivo:</span>
                        <ul>
                            <li>Te facilitaremos un presupuesto de reparación válido durante 30 días hábiles desde su entrega. Si lo aceptas, procederemos con la reparación y si lo rechazas, te facturaremos 5 € por gastos de gestión (6,05 con IVA, 5,35 con IGIC, 5,50 con IPSI Ceuta y 5,40 con IPSI Melilla.). Si no es reparable, te lo devolveremos sin coste.</li>
                            <li>Incluiremos los gastos de reparación o de gestión en tu factura O2.</li>
                            <li>Si la avería no es reparable, te devolveremos el terminal sin ningún coste.</li>
                        </ul>
                        <span class="azulO2">Tratamiento de tus datos personales:</span>
                        <ul class="separado">
                            <li>Trataremos tus datos personales conforme a lo establecido en la Política de Privacidad de O2, cuya información básica se recoge aquí. Dispones de su contenido íntegro en o2online.es/privacidad/. Telefónica de España, S.A.U. y Telefónica Móviles España, S.A.U., del grupo Telefónica, son las empresas corresponsables del tratamiento de tus datos personales, según los productos o servicios que tengas contratados.</li>
                            <li>Trataremos tus datos para la prestación del Servicio, así como para otras finalidades que, como cliente O2, nos permitas o autorices en los términos recogidos en la Política de Privacidad, en la que además se recoge toda la información necesaria para que puedas decidir sobre otros tratamientos que requieran tu consentimiento. Los datos personales necesarios que aportas en este acto para la ejecución del contrato, junto a los obtenidos con motivo de la prestación del Servicio, así como a través de los canales de atención y comercialización, se incluirán en ficheros informatizados de datos de carácter personal titularidad de O2.</li>
                            <li>Adicionalmente a los tratamientos recogidos en la Política de Privacidad, al aceptar los presentes términos y condiciones de uso del Servicio, eres informado y autorizas a O2 al tratamiento específico de los datos facilitados en estas condiciones de reparación, en concreto, tus datos de cliente y del dispositivo averiado, cuyo tratamiento es necesario para la prestación del servicio de reparación.</li>
                            <li>Para cualquier finalidad prevista en nuestra política de privacidad, O2 puede encargar el tratamiento a proveedores de confianza y a aquellos que realizan transferencias internacionales de datos en el ejercicio de sus funciones recogidos en o2online.es/privacidad/info-adicional/. En este sentido, garantizamos la adopción de las medidas necesarias para asegurar el tratamiento confidencial de dichos datos.</li>
                            <li>Si lo deseas, puedes ejercer los derechos de acceso, rectificación, supresión, limitación, oposición y portabilidad mandándonos un email a <span class="azulEnlaceO2">TE_datos@telefonica.com</span> con el asunto DATOS, o si lo prefieres dirigiendo un escrito postal al apartado de Correos 46155, 28080, Madrid, indicando en la solicitud qué derecho ejerce y a qué números de teléfono concretos de las que el cliente es titular afecta la citada solicitud, a nuestras oficinas centrales de nuestra marca O2 en España.</li>
                        </ul>
                        <span class="pieCondiciones">
                            O2 es una marca registrada por el Grupo Telefónica al que pertenecen Telefónica de España, S.A.U. (compañía con C.I.F. A82018474, domiciliada en calle Gran Vía, nº 28, C.P. 28013 – Madrid (España) e inscrita en el Registro Mercantil de Madrid al Tomo 13.170; Libro 0; Sección 8ª; Hoja M213.180) y Telefónica Móviles España, S.A.U. (compañía con C.I.F. A-78923125, domiciliada en Ronda de la Comunicación, s/n, Distrito C, Edificio Sur 3, C.P. 28050 - Madrid (España) e inscrita en el Registro Mercantil de Madrid en el Tomo 8958, Gral. 7804, Sección 3ª, del Libro de Sociedades, Folio 92, H-85226). Dirección de correo electrónico de contacto ayuda@o2online.es. Para más información, consulte la página web www.O2online.es.
                        </span>
                        <div style="display:flex;justify-content:center;margin-top:20px;">
                            <button class="button-search" @click="enviar">
                                <span>ACEPTAR CONDICIONES Y ENVIAR</span>
                            </button>
                        </div>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </section>

    <footer>
        <div style="height: 30px"></div>
        <div class="bloque-alerta">
            <span id="lblMensaje12"></span>
        </div>
    </footer>
    </div>
</template>

<script>
    import incidencia_formulario from "@/Modelos/IncidenciaFormulario";
    import comprobaciones from "@/plugins/comprobaciones.js";

    export default {
        layout: "noZeleris",
        components: {
            customHeader: () => import("@/components/O2/customHeader"),
        },
        created() {
            this.formulario = incidencia_formulario;
            this.formulario.idOrigen = 3
            this.getDesplegables();
        },

        data: () => ({
            //Iniciales
            TiposModelos: undefined,
            Fabricantes: undefined,
            Modelos: undefined,
            modalSN: false,
            modalIMEI: false,
            modalCondiciones: false,
            //Flujo
            pedirDesplegables: {
                idTipoModelo: null,
                idMarca: null,
            },
            localTelefono: "",
            errorTelefono: "",
            localAbonado: "",
            errorAbonado: "",
            localEmail: "",
            errorEmail: "",
            localDNI: "",
            dniCliente: "",
            errorDNI: "",
            localHorario: "",
            observacionesContacto: "",
            localHorarioDesde: "",
            localHorarioHasta: "",
            erroresObligatorios: {
                nombre: "",
                sintoma: "",
                direccion: "",
                cp: "",
                poblacion: "",
                albaran: "",
                horarioContacto: "",
                sn: ""
            },
            //Final
            formulario: {},
            enviandoIncidencia: false,
            consultandoIncidencia: false,
            incidencia: "",
            tipoTextoIncidencia: "",

            toggle_exclusive: "",
            itemsHorariosDesde: ['8:00', '8:30', '9:00', '9:30', '10:00', '10:30', '11:00', '11:30', '12:00', '12:30', '13:00', '13:30', '14:00', '14:30', '15:00', '15:30', '16:00', '16:30', '17:00', '17:30', '18:00', '18:30', '19:00', '19:30', '20:00'],
            itemsHorariosHasta: ['8:00', '8:30', '9:00', '9:30', '10:00', '10:30', '11:00', '11:30', '12:00', '12:30', '13:00', '13:30', '14:00', '14:30', '15:00', '15:30', '16:00', '16:30', '17:00', '17:30', '18:00', '18:30', '19:00', '19:30', '20:00'],
        }),

        watch: {
            pedirDesplegables: {
                deep: true,
                handler(valor) {
                    if (valor.idMarca != null && valor.idTipoModelo != null)
                        this.getDesplegables();
                },
            },
            localHorarioHasta(nuevo) {
                if (nuevo != "" && this.localHorarioDesde != "")
                    this.formulario.metaData.horarioContacto =
                        "Desde " + this.localHorarioDesde + " hasta " + nuevo;
            },
            localHorarioDesde(nuevo) {
                this.localHorarioHasta = "";
                if (nuevo == undefined && nuevo == "") {
                    this.localHorarioHasta = "";
                } else {
                    Object.assign(this.itemsHorariosHasta, this.itemsHorariosDesde);
                    this.itemsHorariosHasta = this.itemsHorariosHasta.splice(this.itemsHorariosDesde.indexOf(nuevo) + 1, this.itemsHorariosDesde.length);
                }
            }
        },

        computed: {
            formularioCompleto() {
                return (
                    this.formulario.metaData.numeroAbonadoCliente != null &&
                    this.formulario.metaData.numeroAbonadoCliente != "" &&
                    this.formulario.metaData.dniCliente != null &&
                    this.formulario.metaData.dniCliente != "" &&
                    this.formulario.metaData.nombreCliente != null &&
                    this.formulario.metaData.nombreCliente != "" &&
                    this.formulario.metaData.emailCliente != null &&
                    this.formulario.metaData.emailCliente != "" &&
                    this.formulario.linea.sintomaAveria != null &&
                    this.formulario.linea.sintomaAveria != "" &&
                    this.formulario.metaData.direccionCliente != null &&
                    this.formulario.metaData.direccionCliente != "" &&
                    this.formulario.metaData.cpCliente != null &&
                    this.formulario.metaData.cpCliente != "" &&
                    this.formulario.metaData.poblacionCliente != null &&
                    this.formulario.metaData.poblacionCliente != "" &&
                    this.formulario.metaData.horarioContacto != null &&
                    this.formulario.metaData.horarioContacto != "" &&
                    this.formulario.metaData.sn != null &&
                    this.formulario.metaData.sn != ""
                );
            },
        },

        methods: {
            getDesplegables() {
                this.$API.getDesplegables(this.pedirDesplegables).then((response) => {
                    if (response.hasOwnProperty("tiposModelos")) {
                        this.TiposModelos = response.tiposModelos;
                        if (response.tiposModelos.length == 1)
                            this.pedirDesplegables.idTipoModelo = response.tiposModelos[0].ID;
                    }
                    if (response.hasOwnProperty("marcas"))
                        this.Fabricantes = response.marcas;
                    if (response.hasOwnProperty("modelos")) this.Modelos = response.modelos;
                });
            },

            changeSelectMarca() {

                if (this.pedirDesplegables.idTipoModelo == 1 && this.pedirDesplegables.idMarca == 77) {
                    if (window.confirm('Para poder recogerse el dispositivo tiene que estar desactivada la función Buscar Mi iPhone. Si necesita ayuda, pulse aceptar para leer el documento')) {
                        window.open('/doc/Desactivar_Buscar_iPhone_2020.pdf', '_blank');
                    };
                }

            },

            checkIncidenciaRepetida() {

                if (!this.consultandoIncidencia) {
                    this.incidencia = "";
                    this.consultandoIncidencia = true;
                    this.formulario.metaData.dniCliente = this.localDNI;
                    let datos = {
                        formulario: this.formulario,
                        familia: this.pedirDesplegables.idTipoModelo,

                    }
                    this.$API.consultarIncidencia(datos).then((response) => {
                        if (response.codigo == 0) {
                            if (response.idincidencia != 0) {
                                alert('Ya existe una incidencia abierta con esos datos. Se ha enviado un email a la cuenta que la ha creado con las instrucciones para consultarla. Incidencia: ' + response.incidencia);
                                //this.tipoTextoIncidencia = "warning";
                                //this.incidencia = response.mensaje;
                            } else {
                                // this.tipoTextoIncidencia = "success";
                                // this.incidencia = "Ya existe una incidencia abierta con esos datos. Se ha enviado un email a la cuenta que la ha creado con las instrucciones para consultarla. Incidencia: " + responseData.incidencia;

                            }
                            // this.vaciarCampos();
                        } else {
                            //this.tipoTextoIncidencia = "warning";
                            //this.incidencia = "Ha habido un error al consultar la incidencia. Por favor, intentelo de nuevo más tarde";
                        }
                        window.scrollTo(0, 0);
                        this.consultandoIncidencia = false;
                        this.modalCondiciones = false;
                    });
                }
            },

            //Validaciones de campos
            comprobarCampos() {
                //this.comprobarTelefono();
                this.comprobarAbonado();
                this.comprobarDNI();
                this.comprobarEmail();
                this.comprobarObligatorios();

                if (!this.formularioCompleto) window.scrollTo(0, 0);
                else this.modalCondiciones = true
            },
            comprobarDNI() {
                let comprobacionesjs = new comprobaciones();
                this.formulario.metaData.dniCliente = "";
                this.errorDNI = "";
                if (this.localDNI == "")
                    this.errorDNI =
                        "El campo <b>'DNI'</b> es obligatorio y no puede estar vacío";
                else if (!comprobacionesjs.isDNI(this.localDNI) && !comprobacionesjs.isNIE(this.localDNI) && !comprobacionesjs.isCIF(this.localDNI) && !comprobacionesjs.isTR(this.localDNI) && !comprobacionesjs.isPassport(this.localDNI))
                    this.errorDNI =
                        "El campo <b>'DNI/CIF/TARJETA RESIDENTE/PASAPORTE'</b> no tiene un formato correcto.";
                else this.formulario.metaData.dniCliente = this.localDNI;
            },
            comprobarTelefono() {
                this.formulario.metaData.telefonoCliente = "";
                this.errorTelefono = "";
                if (this.localTelefono == "")
                    this.errorTelefono =
                        "El campo <b>'Teléfono de Contacto'</b> es obligatorio y no puede estar vacío";
                else if (!/^[0-9]{9}/.test(this.localTelefono))
                    this.errorTelefono =
                        "El campo <b>'Teléfono de Contacto'</b> no tiene un formato correcto, 9 dígitos númericos sin espacios";
                else this.formulario.metaData.telefonoCliente = this.localTelefono;
            },
            comprobarAbonado() {
                this.formulario.metaData.numeroAbonadoCliente = "";
                this.errorAbonado = "";
                if (this.localAbonado == "")
                    this.errorAbonado =
                        "El campo <b>'Número móvil'</b> es obligatorio y no puede estar vacío";
                else if (!/^[0-9]{9}/.test(this.localAbonado))
                    this.errorAbonado =
                        "El campo <b>'Número móvil'</b> no tiene un formato correcto, 9 dígitos númericos sin espacios";
                else this.formulario.metaData.numeroAbonadoCliente = this.localAbonado;
            },
            comprobarEmail() {
                this.formulario.metaData.emailCliente = "";
                this.errorEmail = "";
                if (this.localEmail == "")
                    this.errorEmail =
                        "El campo <b>'Email'</b> es obligatorio y no puede estar vacío";
                else if (!this.localEmail.includes("@") || !this.localEmail.includes("."))
                    this.errorEmail =
                        "El campo <b>'Email'</b> no tiene un formato de email válido";
                else this.formulario.metaData.emailCliente = this.localEmail;
            },
            comprobarObligatorios() {
                Object.entries(this.erroresObligatorios).forEach(([key, value]) => {
                    this.erroresObligatorios[key] = "";
                });
                if (
                    this.formulario.metaData.nombreCliente == null ||
                    this.formulario.metaData.nombreCliente == ""
                )
                    this.erroresObligatorios.nombre =
                        "El campo <b>'Nombre'</b> es obligatorio y no puede estar vacío";
                if (
                    this.formulario.linea.sintomaAveria == null ||
                    this.formulario.linea.sintomaAveria == ""
                )
                    this.erroresObligatorios.sintoma =
                        "El campo <b>'Síntoma de la Avería'</b> es obligatorio y no puede estar vacío";
                if (
                    this.formulario.metaData.direccionCliente == null ||
                    this.formulario.metaData.direccionCliente == ""
                )
                    this.erroresObligatorios.direccion =
                        "El campo <b>'Dirección'</b> es obligatorio y no puede estar vacío";
                if (
                    this.formulario.metaData.cpCliente == null ||
                    this.formulario.metaData.cpCliente == ""
                )
                    this.erroresObligatorios.cp =
                        "El campo <b>'Código Postal'</b> es obligatorio y no puede estar vacío";
                if (
                    this.formulario.metaData.poblacionCliente == null ||
                    this.formulario.metaData.poblacionCliente == ""
                )
                    this.erroresObligatorios.poblacion =
                        "El campo <b>'Población'</b> es obligatorio y no puede estar vacío";
                if (
                    this.formulario.metaData.horarioContacto == null ||
                    this.formulario.metaData.horarioContacto == ""
                )
                    this.erroresObligatorios.horarioContacto =
                        "Los campos <b>'HORARIO DESDE'</b> y <b>'HORARIO HASTA'</b> son obligatorios y no pueden estar vacíos";
                if (
                    this.formulario.metaData.sn == null ||
                    this.formulario.metaData.sn == ""
                )
                    this.erroresObligatorios.sn = "El campo <b>'SN'</b> es obligatorio y no puede estar vacío";
            },

            pincharFileInput() {
                let fileInput = document.getElementById('formO2fileInput')
                fileInput.click();
            },

            //envio final
            async enviar() {

                var encontrado = 0;
                this.formulario.metaData.dniCliente = this.localDNI;
                let datos2 = {
                    formulario: this.formulario,
                    familia: this.pedirDesplegables.idTipoModelo,

                }
                await this.$API.consultarIncidencia(datos2).then((response2) => {

                    if (response2.codigo == 0) {

                        if (response2.idincidencia != 0) {
                            encontrado = 1;
                            //alert('Ya existe una incidencia abierta con esos datos. Se ha enviado un email a la cuenta que la ha creado con las instrucciones para consultarla. Incidencia: ' + response2.incidencia);
                            this.tipoTextoIncidencia = "warning";
                            this.incidencia = 'Ya existe una incidencia abierta con esos datos. Se ha enviado un email a la cuenta que la ha creado con las instrucciones para consultarla. Incidencia: ' + response2.incidencia;
                            window.scrollTo(0, 0);
                        } else {
                            // this.tipoTextoIncidencia = "success";
                            // this.incidencia = "Ya existe una incidencia abierta con esos datos. Se ha enviado un email a la cuenta que la ha creado con las instrucciones para consultarla. Incidencia: " + responseData.incidencia;

                        }
                        // this.vaciarCampos();
                    } else {
                        //this.tipoTextoIncidencia = "warning";
                        //this.incidencia = "Ha habido un error al consultar la incidencia. Por favor, intentelo de nuevo más tarde";
                    }

                });


                if (!this.enviandoIncidencia && encontrado == 0) {
                    this.incidencia = "";
                    this.enviandoIncidencia = true;
                    this.formulario.metaData.dniCliente = this.localDNI;
                    this.$API.resgistarIncidencia({
                        formulario: this.formulario,
                        familia: this.pedirDesplegables.idTipoModelo,
                    })
                        .then((response) => {
                            if (response.codigo == 0) {
                                if (response.incidencia === undefined) {
                                    this.tipoTextoIncidencia = "warning";
                                    this.incidencia = response.mensaje;
                                } else {
                                    this.tipoTextoIncidencia = "success";
                                    this.incidencia =
                                        "Se ha generado la incidencia '" +
                                        response.incidencia +
                                        "' para tratar su gestión";
                                }
                                this.vaciarCampos();
                            } else {
                                this.tipoTextoIncidencia = "warning";
                                this.incidencia =
                                    "Ha habido un error al crear la incidencia. Por favor, intentelo de nuevo más tarde";
                            }
                            window.scrollTo(0, 0);
                            this.enviandoIncidencia = false;
                            this.modalCondiciones = false;
                        });
                }

               
            },
            vaciarCampos() {
                this.localTelefono = "";
                this.localAbonado = "";
                this.localEmail = "";
                this.pedirDesplegables.idTipoModelo = null;
                this.pedirDesplegables.idMarca = null;
                this.formulario = incidencia_formulario;
            },
        },
    };
</script>

<style>
    @font-face {
        font-family: 'OnAir';
        src: url("/fonts/O2/OnAir-Black.woff2") format("woff2"), url("/fonts/O2/OnAir-Black.woff") format("woff");
        font-weight: bolder;
        font-style: normal;
    }

    @font-face {
        font-family: 'OnAir';
        src: url("/fonts/O2/OnAir-BlackItalic.woff2") format("woff2"), url("/fonts/O2/OnAir-BlackItalic.woff") format("woff");
        font-weight: bolder;
        font-style: italic;
    }

    @font-face {
        font-family: 'OnAir';
        src: url("/fonts/O2/OnAir-Bold.woff2") format("woff2"), url("/fonts/O2/OnAir-Bold.woff") format("woff");
        font-weight: bold;
        font-style: normal;
    }

    @font-face {
        font-family: 'OnAir';
        src: url("/fonts/O2/OnAir-BoldItalic.woff2") format("woff2"), url("/fonts/O2/OnAir-BoldItalic.woff") format("woff");
        font-weight: bolder;
        font-style: italic;
    }

    @font-face {
        font-family: 'OnAir';
        src: url("/fonts/O2/OnAir-Regular.woff2") format("woff2"), url("/fonts/O2/OnAir-Regular.woff") format("woff");
        font-weight: normal;
        font-style: normal;
    }

    @font-face {
        font-family: 'OnAir';
        src: url("/fonts/O2/OnAir-Italic.woff2") format("woff2"), url("/fonts/O2/OnAir-Italic.woff") format("woff");
        font-weight: normal;
        font-style: italic;
    }

    @font-face {
        font-family: 'OnAir';
        src: url("/fonts/O2/OnAir-Light.woff2") format("woff2"), url("/fonts/O2/OnAir-Light.woff") format("woff");
        font-weight: normal;
        font-style: normal;
    }

    @font-face {
        font-family: 'OnAir';
        src: url("/fonts/O2/OnAir-LightItalic.woff2") format("woff2"), url("/fonts/O2/OnAir-LightItalic.woff") format("woff");
        font-weight: normal;
        font-style: italic;
    }

    html,
    body,
    div,
    span,
    applet,
    object,
    iframe,
    h1,
    h2,
    h3,
    h4,
    h5,
    h6,
    p,
    blockquote,
    pre,
    a,
    abbr,
    acronym,
    address,
    big,
    cite,
    code,
    del,
    dfn,
    em,
    img,
    ins,
    kbd,
    q,
    s,
    samp,
    small,
    strike,
    strong,
    sub,
    sup,
    tt,
    var,
    b,
    u,
    i,
    center,
    dl,
    dt,
    dd,
    ol,
    ul,
    li,
    fieldset,
    form,
    label,
    legend,
    table,
    caption,
    tbody,
    tfoot,
    thead,
    tr,
    th,
    td,
    article,
    aside,
    canvas,
    details,
    embed,
    figure,
    figcaption,
    footer,
    header,
    hgroup,
    menu,
    nav,
    output,
    ruby,
    section,
    summary,
    time,
    mark {
        font-family: 'OnAir' !important;
    }

    #O2 section {
        min-width: 300px;
        max-width: 620px;
        margin: 0 auto;
    }

    #O2 .info-success {
        background-color: #D8F1F1;
        font-size: 20px;
        color: #0019a5;
        font-weight: bold;
    }

    #O2 .info-check {
        padding-top: 10px;
        padding-left: 20px;
        font-size: 40px;
    }

    #O2 .numered-title-container {
        margin: 40px 0;
    }

    #O2 .numered-title {
        font-size: 40px;
        font-weight: 300;
        line-height: 0.7;
        color: #0019a5;
    }

    #O2 .numered-title-number {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        background-color: #0019a5;
        text-align: center; 
        padding-top:2px;
        font-size: 25px;
        font-weight: bold;
        color: #fff;
    }

    #O2 .input-container {
        margin-bottom: 30px;
    }

    #O2 .label-input {
        font-size: 16px;
        color: #212529;
        padding-bottom: 10px;
    }

    #O2 .error-label {
        font-size: 12.8px;
        font-weight: 500;
        letter-spacing: 0.29px;
        color: #dc3545;
    }

    #O2 .special-label {
        font-size: 24px;
        font-weight: 300;
        margin-bottom: 15px;
    }

    #O2 .conditions-text {
        font-size: 18px;
        line-height: 1.39;
        text-align: justify;
        color: #5d5d5d;
    }

    #O2 .button-search-container, .condiciones .button-search-container {
        display: flex;
        justify-content: center;
        margin-top: 50px;
        margin-bottom: 70px;
    }

    #O2 .button-search, .condiciones .button-search {
        height: 48px;
        padding: 11px 15px;
        border-radius: 30px;
        /*background-color: #0019a5;*/
        background-color: #0050FF;
        font-size: 20px;
        line-height: 1.3;
        text-align: center;
        color: #fff;
    }

    #O2 .button-file {
        height: 55px;
        padding: 11px 34px;
        border-radius: 4px;
        background-color: #F3F3F5;
        font-size: 20px;
        line-height: 1.3;
        text-align: center;
        color: rgba(0, 0, 0, 0.3);
    }

    .condiciones .azulO2 {
        color: #00B0F0;
    }
    .condiciones .azulEnlaceO2 {
        color: #0000FF;
    }
    .condiciones ul {
        padding-left: 15px;
        padding-top: 10px;
        padding-bottom: 10px;
    }
    .condiciones ul.separado > li {
        padding-bottom: 10px;
    }

    .condiciones .pieCondiciones {
        margin-top: 20px;
        font-style: italic;
    }

    @media (max-width: 600px) {
        #O2 section {
            padding: 0 18px;
        }
    }


    #input_o2 {
        background-color: white;
        border-radius: 15px;
        border: 1px solid grey;
        padding: 30px 10px;
        color: #73737D;
    }

    #O2 .v-text-field > .v-input__control > .v-input__slot:after, .v-text-field > .v-input__control > .v-input__slot:before{
    bottom: -1px;
    content: "";
    left: 0;
    position: absolute;
    -webkit-transition: .3s cubic-bezier(.25, .8, .5, 1);
    transition: .3s cubic-bezier(.25, .8, .5, 1);
    width: 0%;
    }

    #txtHoraDesde {
        background-color: white;
        border-color: white;
    }

    #textarea_sintomaAveria {
        background-color: white;
        border: 1px solid grey;
        border-radius: 15px;
        padding:10px 10px;
    }

    #textarea_observacionesContacto {
        background-color: white;
        border: 1px solid grey;
        border-radius: 15px;
        padding: 10px 10px;
    }

    #o2_input_container {
        background-color: white;
        border-radius: 15px;
        border: 1px solid grey;
        padding: 8px 10px;
    }

    #o2_input_container_vtextfield {
        background-color: white;
        border-color: white;
        margin-top: -10px;
    }


    #TiposModelos {
        background-color: white;
        border-color: white;
    }

</style>